import {
    cilArrowCircleTop,
    cilArrowCircleBottom,
    cil3d,
    cilBook,
    cilSignLanguage,
    cilArrowRight,
    cilArrowThickRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilHistory,
    cilChart,
    cilChartPie,
    cilChartLine,
    cilCheck,
    cilMonitor,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilHome,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilLineStyle,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilSpreadsheet,
    cilListRich,
    cilBuilding,
    cilWarning,
    cilInfo,
    cilTouchApp,
    cilSitemap,
    cilBank,
	cilLibrary,
    cilLink,
    cilAddressBook,
    cilMoney,
    cilLocomotive,
    cilAirplaneMode,
    cilBoatAlt,
    cilApplications,
    cilThumbUp,
    cilKeyboard
} from '@coreui/icons'
import { logo } from './logo'
import { cilTool } from './custom/cil-tool'
import { cilAsset } from './custom/cil-asset'
import { cilDatabaseBackup } from './custom/cil-database-backup'
import { cilGuide } from './custom/cil-guide'
import { cilLog } from './custom/cil-log'
import { cilMonitorData } from './custom/cil-monitor-data'
import { cilDataChange } from './custom/cil-data-change'
import { cilAim } from './custom/cil-aim'
import { cilDistributedData } from './custom/cil-distributed-data'
import { cilQuestionMark } from './custom/cil-question-mark'
import { cilParameter } from './custom/cil-parameter'
import { cilHandTruckMoving } from './custom/cil-hand-truck-moving'
import { cilCheckList } from './custom/cil-checklist'
import { cilHandling } from './custom/cil-handling'
import { cilDepartment } from './custom/cil-deparment'
import { cilProject } from './custom/cil-project'
import { cilWaterTap } from './custom/cil-water-tap'
import { cilRoad } from './custom/cil-road'
import { cilSprinkler } from './custom/cil-sprinkler'
import { cilBoatToy } from './custom/cil-boat-toy'
import { cilEllipsis } from './custom/cil-ellipsis'



export const iconsSet = Object.assign(
    {},
    { logo },
    {
        cilEllipsis,
        cilApplications,
        cilThumbUp,
        cilKeyboard,
        cilBoatToy,
        cilSprinkler,
        cilBoatAlt,
        cilAirplaneMode,
        cilLocomotive,
        cilRoad,
        cilWaterTap,
        cilArrowCircleTop,
        cilArrowCircleBottom,
        cil3d,
        cilBook,
        cilSignLanguage,
        cilArrowRight,
        cilArrowThickRight,
        cilBan,
        cilBasket,
        cilBell,
        cilCalculator,
        cilCalendar,
        cilCloudDownload,
        cilHistory,
        cilChart,
        cilChartPie,
        cilChartLine,
        cilCheck,
        cilMonitor,
        cilChevronBottom,
        cilChevronTop,
        cilCheckCircle,
        cilCommentSquare,
        cilCursor,
        cilDrop,
        cilHome,
        cilDollar,
        cilEnvelopeClosed,
        cilEnvelopeOpen,
        cilEuro,
        cilGlobeAlt,
        cilGrid,
        cilFile,
        cilJustifyCenter,
        cilLaptop,
        cilLayers,
        cilLightbulb,
        cilLineStyle,
        cilList,
        cilLocationPin,
        cilLockLocked,
        cilMagnifyingGlass,
        cilMoon,
        cilOptions,
        cilPencil,
        cilPeople,
        cilPuzzle,
        cilSettings,
        cilShieldAlt,
        cilSpeech,
        cilSpeedometer,
        cilStar,
        cilTask,
        cilUser,
        cilUserFemale,
        cilUserFollow,
        cilXCircle,
        cilSpreadsheet,
        cilListRich,
        cilBuilding,
        cilWarning,
        cilInfo,
        cilTouchApp,
        cilTool,
        cilAsset,
        cilDatabaseBackup,
        cilGuide,
        cilLog,
        cilMonitorData,
        cilDataChange,
        cilSitemap,
        cilAim,
        cilDistributedData,
        cilQuestionMark,
        cilParameter,
        cilHandTruckMoving,
        cilCheckList,
        cilHandling,
        cilBank,
        cilDepartment,
        cilProject,
        cilLibrary,
        cilLink,
        cilAddressBook,
        cilMoney
    }
)
